/* global gtag */

export default function trackEvent (category, action, label, value = false, addValueToLabel = false) {
    // ga tracking
    if (typeof ga === 'function') {
        gtag('event', action, {
            event_category: category,
            event_label: addValueToLabel ? `${label}${value ? `_${value}` : ''}` : label,
            value: value,
        });
    }
    // piwik / matomo tracking
    if (typeof _paq === 'object') {
        _paq.push(['trackEvent', category, action, `${label}${value ? `_${value}` : ''}`]);
    }
}
